const queryParamRegex = require('./queryParamRegex');

module.exports = {
  queryParamRegex,
};
